/* Product cards render the French image (Weglot serves /en from the same
   French render). Swap to the English image on English pages, and keep
   swapping for cards added later (filters, section re-renders) or when
   Weglot changes language. */
(function () {
  function pageLang() {
    var lang = '';
    try {
      if (window.Weglot && Weglot.getCurrentLang) lang = Weglot.getCurrentLang() || '';
    } catch (e) {}
    if (!lang) lang = document.documentElement.getAttribute('lang') || 'fr';
    return lang.slice(0, 2).toLowerCase() === 'en' ? 'en' : 'fr';
  }

  function apply() {
    var lang = pageLang();
    var imgs = document.querySelectorAll('img[data-card-lang-swap]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.cardLang === lang) continue;
      var src = img.getAttribute('data-' + lang + '-src');
      if (!src) continue;
      img.setAttribute('srcset', img.getAttribute('data-' + lang + '-srcset') || '');
      img.setAttribute('src', src);
      img.setAttribute('alt', img.getAttribute('data-' + lang + '-alt') || '');
      img.dataset.cardLang = lang;
    }
  }

  apply();
  document.addEventListener('DOMContentLoaded', apply);

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['lang'] });

  function hookWeglot() {
    if (!window.Weglot || !Weglot.on) return false;
    try {
      Weglot.on('initialized', apply);
      Weglot.on('languageChanged', apply);
    } catch (e) {}
    return true;
  }
  if (!hookWeglot()) window.addEventListener('load', hookWeglot);
})();
